import 'reflect-metadata';
import { Service } from 'typedi';
import type { PaginationTypeStrategyData } from '../../types/pagination-strategy-data.type';
import { StrategyBuilder } from '../../StrategyBuilder';
import { PaginationStrategyService } from '../../PaginationStrategyService';

@Service({ id: 'searchPaginationB2cStrategyService' })
export class SearchPaginationB2csStrategyBuilder extends StrategyBuilder<PaginationStrategyService> {
  build(details: PaginationTypeStrategyData): PaginationStrategyService {
      return new SearchPaginationB2cStrategyService(details);
  }
}

export class SearchPaginationB2cStrategyService extends PaginationStrategyService {
  details;
  constructor(details: PaginationTypeStrategyData) {
      super();
      this.details = details;
  }

  makePagination(): string {
      return 'uiaas-tabs-pagination-b2c';
  }

  getPaginationProps(params: Record<string, string>): Record<string, string> {
      if (this.details?.params) {
        return this.details.params;
      }
      return {};
  }
}
